import { expenseConstants } from './constants/expenseConstants';

const getExpense = () => ({
  type: expenseConstants.getExpenseRequest,
}); 

const getExpenseParams = (data: any) => ({
  type: expenseConstants.getExpenseParamsRequest,
  payload: data,
});

const getExpenseView = (data: any) => ({
  type: expenseConstants.expenseViewRequest,
  payload: data,
});

const createExpense = (data: any) => ({
  type: expenseConstants.createExpenseRequest,
  payload: data,
});

const deleteExpense = (data: any) => ({
  type: expenseConstants.deleteExpenseRequest,
  payload: data,
});

const resetCreateExpense = () => ({
  type: expenseConstants.createExpenseReset,
});

const resetDeleteExpense = () => ({
  type: expenseConstants.deleteExpenseReset,
});

export const expenseActions = {
  getExpense,
  getExpenseParams,
  getExpenseView,
  createExpense,
  deleteExpense,
  resetCreateExpense,
  resetDeleteExpense,
};
